'use client'
import { type FC, type ReactNode } from 'react'
import dynamic from 'next/dynamic'
import StyledComponentsRegistry from '@/utils/styled-components-registry'
import { Susy } from '@/styles'
import { PRO, STAGING } from '@/utils'
import { TranslationsProvider, ModalsProvider, ToastProvider, VideoVisibilityProvider } from '@/context'
import { TransitionWrapper } from './TransitionWrapper'
import type { TypeCmsLayout, TypeLang } from '@/schema'
import { Navbar } from '../layout/Navbar'
import { Footer } from '../layout/Footer'

type Props = {
  children: ReactNode
  lang?: TypeLang
  layoutData?: TypeCmsLayout
}

const DynamicModalMenu = dynamic(() => import('../modals/ModalMenu').then(mod => mod.ModalMenu), { ssr: false })
const DynamicModalContact = dynamic(() => import('../modals/ModalContact').then(mod => mod.ModalContact), { ssr: false })
const DynamicModalGallery = dynamic(() => import('../modals/ModalGallery').then(mod => mod.ModalGallery), { ssr: false })

const ClientProviders: FC<Props> = ({ children, lang, layoutData }) => {
  return (
    <StyledComponentsRegistry>
      <TranslationsProvider paramLang={lang}>
        <ToastProvider>
          <VideoVisibilityProvider>
            <ModalsProvider>
              <TransitionWrapper>
                <Navbar menuLinks={layoutData?.menu} />
                {children}
                <Footer />
                <DynamicModalMenu menuLinks={layoutData?.menu} />
                <DynamicModalContact />
                <DynamicModalGallery />
              </TransitionWrapper>
            </ModalsProvider>
          </VideoVisibilityProvider>
        </ToastProvider>
      </TranslationsProvider>
      {(!STAGING && !PRO) && <Susy />}
    </StyledComponentsRegistry>
  )
}

export default ClientProviders
